export default function removePriceFromServiceTypeName(name: string): string {
  return name.replace(/ - \$\d+/, '');
}
